<template>
  <div class="page_home">
    <div class="home-header">
      <el-image style="width: 100%;height: 100%" :src="require('@/assets/images/header/header3.png')"></el-image>
    </div>
    <div class="home-main">
      <div class="home-content">
        <div class="jyxx">
          <div class="jyxx-header">
            <el-image style="width: 467px;height: 15px;" :src="require('@/assets/images/public/ggleft.png')"></el-image>
            <el-image style="width: 202px;height: 69px;margin:0 32px" :src="require('@/assets/images/homeImages/login.png')"></el-image>
            <el-image style="width: 467px;height: 15px;" :src="require('@/assets/images/public/ggRight.png')"></el-image>
          </div>
          <div style="display: flex;justify-content: space-between;align-items: center;padding: 28px 0 ">
            <div v-for="(item,index) in logOn" :key="item.type">
              <el-image @mouseenter="logOn[index].isHover = true" @mouseleave="logOn[index].isHover = false" @click="goToLogin(item)" style="width: 236px;height: 268px"  :src="!item.isHover ? item.icon : item.hoverImg" fit="fill"></el-image>
            </div>
          </div>
        </div>
        <div class="jyxx">
          <div class="jyxx-header">
            <el-image style="width: 467px;height: 15px;" :src="require('@/assets/images/public/ggleft.png')"></el-image>
            <el-image style="width: 202px;height: 69px;margin:0 32px" :src="require('@/assets/images/homeImages/gglist.png')"></el-image>
            <el-image style="width: 467px;height: 15px;" :src="require('@/assets/images/public/ggRight.png')"></el-image>
          </div>
          <div style="display: flex;justify-content: space-between;align-items: flex-start">
            <div style="font-size: 17px;color: #2A3540;cursor: pointer;width: 200px;box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.25);box-sizing: border-box">
              <div v-for="(item,index) in cgType" :key="item.value" style="width:100%;padding: 20px 16px;box-sizing: border-box;height: 64px"
                   :style="item.value === cgQueryParam.ggAnnouncement ? 'color: #FFFFFF;background: linear-gradient( 270deg, #4B9EFF 0%, #0059C0 100%);;' : 'background: #FFFFFF;'"
                   @click="cgSelect(item)">
                <div  style="display: flex;justify-content: space-between;align-items: center">
                  <div>{{ item.label }}</div>
                  <div style="width: 18px;height: 18px">
                    <el-image v-if="item.value !== cgQueryParam.ggAnnouncement" style="width: 100%;height: 100%" :src="require('@/assets/images/homeImages/wxzJT.png')"></el-image>
                    <el-image v-else style="width: 100%;height: 100%" :src="require('@/assets/images/homeImages/xzJT.png')"></el-image>
                  </div>
                </div>
              </div>
            </div>
            <div style="width: calc(100% - 220px)">
              <div class="jyxx-content">
                <el-table :data="cgList" style="width: 100%" :highlight-current-row="true" @row-click="rowGGClick" :header-cell-style="{ background: '#F1F5F9',}">
                  <el-table-column prop="biddingType" label="采购方式" align="center"  width="100">
                    <template slot-scope="{row}">
                      <div v-for="items in biddingTypeList" :key="items.value" >
                        <div v-if="items.value === row.biddingType"> {{ items.label  }}</div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ggName"  align="left" label="公告标题" min-width="180" :show-overflow-tooltip="true"></el-table-column>
                  <el-table-column prop="ggStartTime"  align="center" label="发布时间" width="180"></el-table-column>
                </el-table>

              </div>
              <div class="jyxx-foot">
                <div style="font-weight: 400;font-size: 16px;color: #094287;cursor: pointer;margin-left: 8px" @click="toPath('/about')" >查看更多
                  <el-image style="width: 16px;height: 9px;" :src="require('@/assets/images/public/rightJT.png')"></el-image>
                </div>
              </div>
            </div>
          </div>


        </div>

        <div class="jyxx" style="">
          <div class="jyxx-header">
            <el-image style="width: 467px;height: 15px;" :src="require('@/assets/images/public/ggleft.png')"></el-image>
            <el-image style="width: 202px;height: 69px;margin:0 32px" :src="require('@/assets/images/homeImages/zblist.png')"></el-image>
            <el-image style="width: 467px;height: 15px;" :src="require('@/assets/images/public/ggRight.png')"></el-image>
          </div>
          <div style="display: flex;justify-content: space-between;align-items: flex-start">
            <div style="font-size: 17px;color: #2A3540;cursor: pointer;width: 200px;box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.25);box-sizing: border-box">
              <div v-for="(item,index) in zbType" :key="item.value" style="width:100%;padding: 20px 16px;box-sizing: border-box;height: 64px"
                   :style="item.value === zbQueryParam.ggAnnouncement ? 'color: #FFFFFF;background: linear-gradient( 270deg, #4B9EFF 0%, #0059C0 100%);;' : 'background: #FFFFFF;'"
                   @click="zbSelect(item)">
                <div   style="display: flex;justify-content: space-between;align-items: center">
                  <div>{{ item.label }}</div>
                  <div style="width: 18px;height: 18px">
                    <el-image v-if="item.value !== zbQueryParam.ggAnnouncement" style="width: 100%;height: 100%" :src="require('@/assets/images/homeImages/wxzJT.png')"></el-image>
                    <el-image v-else style="width: 100%;height: 100%" :src="require('@/assets/images/homeImages/xzJT.png')"></el-image>
                  </div>
                </div>
              </div>
            </div>
            <div style="width: calc(100% - 220px)">
              <div class="jyxx-content">
                <el-table :data="zbList" style="width: 100%" :highlight-current-row="true" @row-click="rowGGClick" :header-cell-style="{ background: '#F1F5F9',}">
                  <el-table-column prop="biddingType" label="采购方式" align="center"  width="100">
                    <template slot-scope="{row}">
                      <div v-for="items in biddingTypeList" :key="items.value" >
                        <div v-if="items.value === row.biddingType"> {{ items.label  }}</div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="ggName"  align="left" label="公告标题" min-width="180" :show-overflow-tooltip="true"></el-table-column>
                  <el-table-column prop="ggStartTime"  align="center" label="发布时间" width="180"></el-table-column>
                </el-table>
              </div>
              <div class="jyxx-foot">
                <div style="font-weight: 400;font-size: 16px;color: #094287;cursor: pointer;margin-left: 8px" @click="toPath('/about')" >查看更多
                  <el-image style="width: 16px;height: 9px;" :src="require('@/assets/images/public/rightJT.png')"></el-image>
                </div>
              </div>
            </div>
          </div>


        </div>

      </div>

    </div>
  </div>
</template>

<script>
import {
  toolslist,
  getGgListApi, getRegionYzApi,getNotificationListApi,
} from "@/api/api";


import dlLogin from '@/assets/images/public/dlLogin.png'
import dlLoginHover from '@/assets/images/public/dlLoginHover.png'
import tbLogin from '@/assets/images/public/tbLogin.png'
import tbLoginHover from '@/assets/images/public/tbLoginHover.png'
import jdLogin from '@/assets/images/public/jdLogin.png'
import jdLoginHover from '@/assets/images/public/jdLoginHover.png'
import yzLogin from '@/assets/images/public/yzLogin.png'
import yzLoginHover from '@/assets/images/public/yzLoginHover.png'
import pbLogin from '@/assets/images/public/pbLogin.png'
import pbLoginHover from '@/assets/images/public/pbLoginHover.png'



export default {

  data() {
    return {
      logOn: [
        {icon:yzLogin, hoverImg:yzLoginHover,title: "业主登录", path: "/login",type: '1',isHover:false},
        {icon:dlLogin ,hoverImg:dlLoginHover, title: "代理机构登录", path: "/login",type:'3',isHover:false},
        {icon:tbLogin ,hoverImg: tbLoginHover, title: "投标人登录", path: "/login",type:'2',isHover:false },
        {icon:jdLogin,hoverImg: jdLoginHover, title: "监督/资审通道(新)", path: "/superviseLinks",isHover:false},
        {icon: pbLogin,hoverImg: pbLoginHover, title: "评标专家登录", path: "/PBLoginMain",isHover:false},
      ],
      cgType:[
        {label: "招标公告",  value: 'zbgg'},
        {label: "变更公告",  value: 'bggg'},
        {label: "资格预审公告",  value: 'zgysgg'},
        {label: "供应商征集",  value: 'GYS'},
        // {label: "专家征集",  value: 'ZJ'},
      ],
      cgList:[],
      cgQueryParam:{pageSize: 10, page: 1,ggAnnouncement:'zbgg',},
      zbType:[
        {label: "中标候选人公示",  value: 'zbhxrgs'},
        {label: "中标公告",  value: 'zhongbiaogg'},
      ],
      zbList:[],
      zbQueryParam:{pageSize: 10, page: 1,ggAnnouncement:'zbhxrgs',},
      registerList:{},
      biddingTypeList:[
        {label: "全部",  value: ''},
        {label: "公开招标",  value: '1'},
        {label: "邀请招标",  value: '2'},
        {label: "询价采购",  value: '3'},
        {label: "竞争性谈判",  value: '4'},
        {label: "竞争性磋商",  value: '5'},
        {label: "框架协议",  value: '6'},
        {label: "直接采购",  value: '7'},
        {label: "比选采购",  value: '8'},
        {label: "竞价采购",  value: '9'},
        {label: "直接选定",  value: '0'},
      ],
    };
  },
  created() {
    this.zoneId = `${process.env.VUE_APP_ZONID }`
    this.cgQueryParam.tenantId = this.zoneId
    this.zbQueryParam.tenantId = this.zoneId
  },
  mounted() {
    this.init()

  },
  methods: {
    async init(){
      await this.cg()
      await this.zb()
    },
    async cgSelect(val){
      this.cgQueryParam.ggAnnouncement=val.value
      await this.cg()
    },
    async cg(){
      const {data} = await getGgListApi(this.cgQueryParam)
      this.cgList = data.items || []
    },
    async zbSelect(val){
      this.zbQueryParam.ggAnnouncement = val.value
      await this.zb()
    },
    async zb(){
      const {data} =await getGgListApi(this.zbQueryParam)
      this.zbList = data.items || []
    },



    async goToLogin(val){
        if(val.path === '/PBLoginMain'){
          let url = location.origin + `${process.env.VUE_APP_PB_LOGOION}${this.zoneId}index.html#/login`
          window.open(url, '_blank');
          return
        }
        await this.$router.push({path: val.path,query:{type:val.type} })

    },
    toPath(val){
      this.$router.push({path: val,})
    },
    rowGGClick(row){
      this.ggDetail(row)
    },
    ggDetail(val,type){
      let path = '/ggDetail'
      if(val.ggAnnouncement === 'GYS' || val.ggAnnouncement === 'ZJ'){
        path = '/collectGgDetail'
      }
      let router =  this.$router.resolve({path: path, query: {id: val.id}});
      window.open(router.href, '_blank');
    },

  },
};
</script>
<style scoped>
.page_home{
  box-sizing: border-box;
  background: #FFFFFF;
}
.home-main{
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;

}
.home-content{
  width:1260px;

}
.jyxx{
  margin: 32px 0;
}
.jyxx-header{
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  margin-bottom: 28px;
  box-sizing: border-box;
}
.jyxx-content{
  min-height: 384px;
}
.jyxx-foot{
  height: 44px;
  background: #F9F9F9;
  border: 1px solid #DCDCDC;
  display: flex;
  justify-content: center;
  align-items: center;
}
.Itme{
  overflow: hidden;
  text-overflow: ellipsis; /* 设置文本溢出时显示省略号 */
  white-space: nowrap; /* 设置不换行 */
}
</style>
